<template>
  <div class="control-input" v-show="visibility">
    <input 
      type="number"
      :placeholder="ikey"
      :readonly="readonly"
      :value="value"
      @input="change($event)"
      @dblclick.stop=""
      @pointerdown.stop=""
      @pointermove.stop=""
    />
  </div>
</template>

<script>
  import timeSlices from '../../util/density/timeSlices';
  
  export default {
    name: 'VueConditionalNumControl',
    props: ['readonly', 'emitter', 'ikey', 'ivisibilityindex', 'getData', 'putData'],
    data: () => {
      return {
        value: 0,
        visibility: false,
      }
    },
    methods: {
      change(e){
        this.value = +e.target.value;
        this.update();
      },
      update() {
        if (this.ikey)
          this.putData(this.ikey, this.value)
        this.emitter.trigger('process');
      },	
    timesliceconf() {
      return timeSlices();
    },
    },
    mounted() {
      this.value = this.getData(this.ikey);
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /*.node .control-input {
    padding: 6px 18px;
  }*/
</style>
